import StyledTableCell from "@components/Table/TableCell";
import StyledTableRow from "@components/Table/TableRow";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";

export interface ModelFileCSVViewerSkeletonProps {
  numberOfColumns?: number;
  numberOfRows?: number;
}
export const ModelFileCSVViewerSkeleton = ({
  numberOfColumns = 6,
  numberOfRows = 10
}: ModelFileCSVViewerSkeletonProps) => {
  return (
    <Box>
      <TableContainer
        className="w-full mt-8 overflow-y-scroll"
        sx={{ maxHeight: "calc(100vh - 450px)", minHeight: 300 }}
      >
        <Table stickyHeader aria-label="skeleton table">
          <TableHead>
            <TableRow>
              {Array.from({ length: numberOfColumns }).map((_, index) => (
                <StyledTableCell
                  key={`skeleton-header-${index}`}
                  align="center"
                  style={{
                    minWidth: 100,
                    borderRight:
                      index === numberOfColumns - 1
                        ? "none"
                        : "1px solid #caccce"
                  }}
                >
                  <Skeleton variant="text" height={24} />
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: numberOfRows }).map((_, rowIndex) => (
              <StyledTableRow
                sx={{ "& > *": { borderBottom: "unset" } }}
                key={`skeleton-row-${rowIndex}`}
              >
                {Array.from({ length: numberOfColumns }).map((_, colIndex) => (
                  <StyledTableCell
                    key={`skeleton-cell-${rowIndex}-${colIndex}`}
                  >
                    <Skeleton variant="text" height={20} />
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
